import { normalizeNullValue } from '../address.utils';

export const entranceField = {
    read(value) {
        return normalizeNullValue(value);
    },
};
